/**
 * GENERATED by scripts/bake-habitat.mjs -- do not edit. Re-run the script.
 *
 * The habitat kit, baked from the Fusion 360 CAD. 16 modules,
 * 82566 triangles, three shading groups each. See the script for why the CAD
 * replaced the procedural builders and how Fusion's appearances map onto the
 * engine's material tags.
 *
 * The geometry itself is a binary asset, fetched at boot -- inlining it would
 * be megabytes of base64 in a module, which is what broke the dev server when
 * the environment probes grew. See HAB_KIT_URL.
 */

/** Floats per vertex: pos(3) nrm(3) uv(2) mat(1). Matches VERT_FLOATS. */
export const HAB_KIT_STRIDE = 9;

/** Where the baked geometry lives. Content-hashed, so sw.js serves it cache-first. */
export const HAB_KIT_URL = '/hab/kit-3288462f.bin';

/** Total size of the blob, for rejecting a short or truncated fetch. */
export const HAB_KIT_BYTES = 4076784;

export interface HabKitGroup {
  /** Byte offset of the vertex block. */
  vOff: number;
  /** Vertices, not floats. */
  vCount: number;
  /** Byte offset of the index block. */
  iOff: number;
  iCount: number;
}

export interface HabKitEntry {
  name: string;
  /** Module bounds in metres, game axes: X length, Y up, Z depth. */
  lo: readonly [number, number, number];
  hi: readonly [number, number, number];
  /**
   * paint and metal are both opaque but shade as different materials -- a
   * dielectric and a conductor. glass is crystal, drawn translucent through
   * fsGlass. glow is the emissive strips. A group is absent when the module
   * has none of it.
   */
  groups: {
    paint?: HabKitGroup; metal?: HabKitGroup;
    glass?: HabKitGroup; glow?: HabKitGroup;
    lamp?: HabKitGroup; cabin?: HabKitGroup;
  };
}

export const HAB_KIT: readonly HabKitEntry[] = [
 {
  name: "collar",
  lo: [
   0,
   -1.545481,
   -1.3
  ],
  hi: [
   0.45,
   1.5,
   1.593912
  ],
  groups: {
   metal: {
    vOff: 0,
    vCount: 2074,
    iOff: 74664,
    iCount: 5826
   }
  }
 },
 {
  name: "hab_core",
  lo: [
   0,
   -3.45,
   -3.25
  ],
  hi: [
   12.000001,
   4.75,
   3.25
  ],
  groups: {
   paint: {
    vOff: 97968,
    vCount: 2432,
    iOff: 185520,
    iCount: 7332
   },
   metal: {
    vOff: 214848,
    vCount: 5310,
    iOff: 406008,
    iCount: 14562
   },
   glass: {
    vOff: 464256,
    vCount: 296,
    iOff: 474912,
    iCount: 876
   },
   lamp: {
    vOff: 478416,
    vCount: 24,
    iOff: 479280,
    iCount: 36
   },
   cabin: {
    vOff: 479424,
    vCount: 2594,
    iOff: 572808,
    iCount: 8712
   }
  }
 },
 {
  name: "hab_cross",
  lo: [
   0,
   -2.45,
   -2.05
  ],
  hi: [
   4,
   2.45,
   2.05
  ],
  groups: {
   metal: {
    vOff: 607656,
    vCount: 12745,
    iOff: 1066476,
    iCount: 37362
   },
   glass: {
    vOff: 1215924,
    vCount: 276,
    iOff: 1225860,
    iCount: 816
   }
  }
 },
 {
  name: "hab_dock",
  lo: [
   0,
   -4.3,
   -2.5
  ],
  hi: [
   5.4,
   2.95,
   2.5
  ],
  groups: {
   paint: {
    vOff: 1229124,
    vCount: 1226,
    iOff: 1273260,
    iCount: 4272
   },
   metal: {
    vOff: 1290348,
    vCount: 3381,
    iOff: 1412064,
    iCount: 9690
   },
   glass: {
    vOff: 1450824,
    vCount: 24,
    iOff: 1451688,
    iCount: 36
   },
   lamp: {
    vOff: 1451832,
    vCount: 24,
    iOff: 1452696,
    iCount: 36
   },
   cabin: {
    vOff: 1452840,
    vCount: 24,
    iOff: 1453704,
    iCount: 36
   }
  }
 },
 {
  name: "hab_elbow",
  lo: [
   0,
   -2,
   -2.05
  ],
  hi: [
   4,
   2.45,
   2.05
  ],
  groups: {
   metal: {
    vOff: 1453848,
    vCount: 7884,
    iOff: 1737672,
    iCount: 23130
   },
   glass: {
    vOff: 1830192,
    vCount: 272,
    iOff: 1839984,
    iCount: 804
   }
  }
 },
 {
  name: "hab_extract",
  lo: [
   0,
   -2.5,
   -2.5
  ],
  hi: [
   6.900001,
   2.5,
   2.5
  ],
  groups: {
   paint: {
    vOff: 1843200,
    vCount: 1386,
    iOff: 1893096,
    iCount: 4098
   },
   metal: {
    vOff: 1909488,
    vCount: 2636,
    iOff: 2004384,
    iCount: 7212
   },
   glass: {
    vOff: 2033232,
    vCount: 248,
    iOff: 2042160,
    iCount: 732
   }
  }
 },
 {
  name: "hab_green",
  lo: [
   0,
   -2.2,
   -2.25
  ],
  hi: [
   8,
   2.2,
   2.25
  ],
  groups: {
   paint: {
    vOff: 2045088,
    vCount: 1728,
    iOff: 2107296,
    iCount: 4848
   },
   metal: {
    vOff: 2126688,
    vCount: 3956,
    iOff: 2269104,
    iCount: 10644
   },
   glass: {
    vOff: 2311680,
    vCount: 48,
    iOff: 2313408,
    iCount: 72
   },
   lamp: {
    vOff: 2313696,
    vCount: 24,
    iOff: 2314560,
    iCount: 36
   },
   cabin: {
    vOff: 2314704,
    vCount: 24,
    iOff: 2315568,
    iCount: 36
   }
  }
 },
 {
  name: "hab_leg",
  lo: [
   0,
   -1.1,
   -0.45
  ],
  hi: [
   0.9,
   0,
   0.45
  ],
  groups: {
   metal: {
    vOff: 2315712,
    vCount: 848,
    iOff: 2346240,
    iCount: 2508
   }
  }
 },
 {
  name: "hab_lo",
  lo: [
   0,
   -3,
   -3
  ],
  hi: [
   12.000001,
   3,
   3
  ],
  groups: {
   paint: {
    vOff: 2356272,
    vCount: 48,
    iOff: 2358000,
    iCount: 84
   }
  }
 },
 {
  name: "hab_obs",
  lo: [
   0,
   -0.45,
   -2.900723
  ],
  hi: [
   6.1,
   3.75,
   2.900723
  ],
  groups: {
   paint: {
    vOff: 2358336,
    vCount: 1146,
    iOff: 2399592,
    iCount: 3408
   },
   metal: {
    vOff: 2413224,
    vCount: 1962,
    iOff: 2483856,
    iCount: 5346
   },
   glass: {
    vOff: 2505240,
    vCount: 90,
    iOff: 2508480,
    iCount: 348
   }
  }
 },
 {
  name: "hab_power",
  lo: [
   0,
   -2.5,
   -2.5
  ],
  hi: [
   5,
   3,
   2.529217
  ],
  groups: {
   paint: {
    vOff: 2509872,
    vCount: 2358,
    iOff: 2594760,
    iCount: 6984
   },
   metal: {
    vOff: 2622696,
    vCount: 4780,
    iOff: 2794776,
    iCount: 13812
   },
   glass: {
    vOff: 2850024,
    vCount: 248,
    iOff: 2858952,
    iCount: 732
   },
   glow: {
    vOff: 2861880,
    vCount: 24,
    iOff: 2862744,
    iCount: 36
   },
   lamp: {
    vOff: 2862888,
    vCount: 24,
    iOff: 2863752,
    iCount: 36
   },
   cabin: {
    vOff: 2863896,
    vCount: 24,
    iOff: 2864760,
    iCount: 36
   }
  }
 },
 {
  name: "hab_refine",
  lo: [
   0,
   -2.5,
   -2.5
  ],
  hi: [
   7,
   5.3,
   2.5
  ],
  groups: {
   paint: {
    vOff: 2864904,
    vCount: 2076,
    iOff: 2939640,
    iCount: 6108
   },
   metal: {
    vOff: 2964072,
    vCount: 4298,
    iOff: 3118800,
    iCount: 11892
   },
   glass: {
    vOff: 3166368,
    vCount: 248,
    iOff: 3175296,
    iCount: 732
   },
   glow: {
    vOff: 3178224,
    vCount: 24,
    iOff: 3179088,
    iCount: 36
   },
   lamp: {
    vOff: 3179232,
    vCount: 24,
    iOff: 3180096,
    iCount: 36
   },
   cabin: {
    vOff: 3180240,
    vCount: 24,
    iOff: 3181104,
    iCount: 36
   }
  }
 },
 {
  name: "hab_store",
  lo: [
   0,
   -2.5,
   -2.5
  ],
  hi: [
   6.5,
   2.5,
   2.5
  ],
  groups: {
   paint: {
    vOff: 3181248,
    vCount: 2172,
    iOff: 3259440,
    iCount: 6336
   },
   metal: {
    vOff: 3284784,
    vCount: 3976,
    iOff: 3427920,
    iCount: 10740
   },
   glass: {
    vOff: 3470880,
    vCount: 192,
    iOff: 3477792,
    iCount: 564
   },
   lamp: {
    vOff: 3480048,
    vCount: 24,
    iOff: 3480912,
    iCount: 36
   },
   cabin: {
    vOff: 3481056,
    vCount: 24,
    iOff: 3481920,
    iCount: 36
   }
  }
 },
 {
  name: "hab_tee",
  lo: [
   0,
   -2,
   -2.05
  ],
  hi: [
   4,
   2.45,
   2.05
  ],
  groups: {
   metal: {
    vOff: 3482064,
    vCount: 10357,
    iOff: 3854916,
    iCount: 30126
   },
   glass: {
    vOff: 3975420,
    vCount: 276,
    iOff: 3985356,
    iCount: 816
   }
  }
 },
 {
  name: "hab_tray",
  lo: [
   0,
   -0.14,
   -0.17
  ],
  hi: [
   3,
   0.14,
   0.17
  ],
  groups: {
   metal: {
    vOff: 3988620,
    vCount: 96,
    iOff: 3992076,
    iCount: 180
   }
  }
 },
 {
  name: "hab_tube",
  lo: [
   0,
   -1.599693,
   -1.599572
  ],
  hi: [
   3,
   1.6,
   1.599469
  ],
  groups: {
   metal: {
    vOff: 3992796,
    vCount: 1675,
    iOff: 4053096,
    iCount: 5418
   },
   glow: {
    vOff: 4074768,
    vCount: 24,
    iOff: 4075632,
    iCount: 36
   },
   cabin: {
    vOff: 4075776,
    vCount: 24,
    iOff: 4076640,
    iCount: 36
   }
  }
 }
] as const;

/** By module name, for the places that want one. */
export const HAB_KIT_BY_NAME: Readonly<Record<string, HabKitEntry>> =
  Object.fromEntries(HAB_KIT.map((e) => [e.name, e]));
